export function flip<First = string, Second = string>(
  value: First | Second | undefined,
  vals: readonly [First, Second],
): First | Second | undefined {
  const [first, second] = vals;
  if (value === first) return second;
  if (value === second) return undefined;

  return first;
}
